export default "__VITE_ASSET__xnQ9E4tL__"